import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { MaterialRequisitionFormResponse } from '@Types/api/form';
import { parseDateTime } from '@Utils/transformDateTime';

interface FieldSourceProps {
  data: MaterialRequisitionFormResponse;
  costCenterTypeDesc: string | undefined;
  costCenter: string | undefined;
}

const fieldSource = ({
  data,
  costCenterTypeDesc,
  costCenter,
}: FieldSourceProps): Array<{
  label: string;
  value: string | number | boolean;
}> => {
  const { reqNo, updatedOn, statusId } = data;

  const source = {
    Status: statusId,
    'Request No.': reqNo,
    'Request Type': 'Material',
    'Request Date': parseDateTime(updatedOn),
    'Cost Center Type': costCenterTypeDesc || EMPTY_FIELD_PLACEHOLDER,
    'Cost Center': costCenter || EMPTY_FIELD_PLACEHOLDER,
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export default fieldSource;
